import React, { Component, Fragment, PureComponent } from 'react';
import { inject, observer } from 'mobx-react';

// type 0 - error
// type 1 - success

@inject('dictStore')
@observer
export default class Message extends Component {
	render() {
		const {text, onClose, type} = this.props;
		const {getLang} = this.props.dictStore;
		return(
			<div className={`result-container ${type == 'success' || type == 1 ? '' : 'result-error'}`}>
        <div className="result-close right" onClick={onClose}></div>
        <div className="result-text" dangerouslySetInnerHTML={{__html: getLang(text)}}></div>
    	</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/message/index.js